module.exports = __webpack_public_path__ + "static/media/mouse_tips.aa844148.png";